import * as channelRoutines from '../channelRoutines';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import { call, put, select } from 'redux-saga/effects';
import { rsf } from '../../../globals/firebase';
import moment from 'moment';

export function* sendMessageSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const activeChannel = yield select(rootSelectors.selectActiveChannelId);
    const alertUser = yield select(rootSelectors.selectAlertUser);
    let name = alertUser.name || 'AlertUser';
    try {
        const message = yield call(
            rsf.database.create,
            paths.moduleData(activeEvent, 'chat', 'messages', activeChannel),
            {
                senderId: 'AlertUser',
                senderName: name,
                text: action.payload,
                timestamp: parseFloat(moment().format('X')),
            },
        );
        put(channelRoutines.sendMessageAsAlertUser.success(message));
    } catch (error) {
        put(channelRoutines.sendMessageAsAlertUser.failure(error));
    }
}

export function* blockMessage(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const activeChannel = yield select(rootSelectors.selectActiveChannelId);
    const { id, status } = action.payload;

    try {
        yield call(rsf.database.patch, paths.moduleData(activeEvent, 'chat', 'messages', activeChannel, id), {
            isBlockedByAdmin: status,
        });
        put(channelRoutines.toggleBlockChannelMessage.success());
    } catch (error) {
        put(channelRoutines.toggleBlockChannelMessage.failure(error));
    }
}
